<template>
    <Modal ref="modal" class="order-history-order-returned-products-updated-details-modal">
        <template #button="sp">
            <button class="btn btn-sm btn-outline-secondary" @click="sp.showModal">
                <i class="fad fa-fw fa-eye"></i> Détails
            </button>
        </template>
        <template #header>
            <div class="h3">Détails des changements</div>
        </template>
        <template #body="sp">
            <span class="h4">Changements sur les retours produits</span>

            <table v-if="returnedProducts" class="table table-sm">
                <thead class="thead-dark">
                <tr>
                    <th scope="col">Avant</th>
                    <th scope="col">Après</th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <template v-for="(quantity, sku) in context.old">
                                <span v-if="quantity" :class="{'font-weight-bold': returnedProducts[sku].old != returnedProducts[sku].new}">
                                    {{ quantity }}x {{ sku }}
                                </span>
                                <br>
                            </template>
                        </td>
                        <td>
                            <template v-for="(quantity, sku) in context.new">
                                <span v-if="quantity" :class="{'font-weight-bold': returnedProducts[sku].old != returnedProducts[sku].new}">
                                    {{ quantity }}x {{ sku }}
                                </span>
                                <br>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template #footer="sp">
            <button class="btn btn-secondary" @click="sp.closeModal()">Fermer</button>
        </template>
    </Modal>
</template>

<script>
import Modal from './Modal';

export default {
    name: 'OrderHistoryOrderReturnedProductsUpdatedDetailsModal',

    components: {
        Modal,
    },

    props: {
        order: {
            type: Object,
            required: true,
        },
        context: {
            type: Object,
            required: true,
        },
    },

    computed: {
        returnedProducts() {
            let products = {};
            if (this.context.old && this.context.new) {
                for (const sku in this.context.old) {
                    products[sku] = products[sku] || {};
                    products[sku]['old'] = this.context.old[sku];
                    products[sku]['new'] = this.context.new[sku] || 0;
                }
                for (const sku in this.context.new) {
                    products[sku] = products[sku] || {};
                    products[sku]['old'] = this.context.old[sku] || 0;
                    products[sku]['new'] = this.context.new[sku];
                }
            }
            return products;
        },
    },
}
</script>

<style lang="scss">
    .order-history-order-returned-products-updated-details-modal {
        .modal-container {
            max-width: 600px!important;
            width: auto;
        }
    }
</style>
